import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const CarretRightIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 24 24", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4.29289C8.39052 3.90237 9.02369 3.90237 9.41421 4.29289L16.4853 11.364C16.8758 11.7545 16.8758 12.3877 16.4853 12.7782L9.41421 19.8492C9.02369 20.2398 8.39052 20.2398 8 19.8492", fill: "currentColor" }) }));
};
export default CarretRightIcon;
//# sourceMappingURL=CarretRightIcon.js.map